import logo1 from "../../assets/img/nxtEvents/LogoOnlysPPV/Arrival.png";

export const nxtArrivalDetail = {
  "nxt-arrival": {
    id: "nxt-arrival",
    title: "NXT Arrival",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "nxt-arrival",
        items: [
          {
            id: "nxt-arrival-2014",
            title: "Arrival",
            description: "2014",
            imgUrl: logo1,
          },
        ],
      },
    ],
  },
};
